import { render, staticRenderFns } from "./canteenRecord.vue?vue&type=template&id=5ca46042&scoped=true"
import script from "./canteenRecord.vue?vue&type=script&lang=js"
export * from "./canteenRecord.vue?vue&type=script&lang=js"
import style0 from "./canteenRecord.vue?vue&type=style&index=0&id=5ca46042&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5ca46042",
  null
  
)

export default component.exports